<template>
  <v-container
    grid-list-xs
    class="pa-0"
    v-if="this.loading != true && this.data.length > 0"
  >
    <v-data-iterator
      :items="membership"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar 
          dark
          flat
          height="60"
          color="primary"
          class="mb-1">
          <template>
            <v-select
              v-model="sortBy"
              flat
              dense
              solo-inverted
              hide-details
              :items="keys"
              prepend-inner-icon="mdi-sort-variant"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle background-color="rgba(0,0,0,0)" v-model="sortDesc" mandatory>
              <v-btn color="secondary" height="40" :value="false">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn color="secondary" height="40" :value="true">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row class="px-4">
          <v-col v-for="item in props.items" :key="item.membership" cols="12" sm="6" md="4" lg="3">
            <v-card outlined class="mt-2">
              <!-- <v-card-title
                class="subheading font-weight-bold"
              >{{ item[0]._id.month.split('T')[0].split('-').slice(0,2).join('/') }}</v-card-title> -->
              <v-card-title class="subheading font-weight-bold">{{ item._id.group }}</v-card-title>

              <v-divider></v-divider>

              <v-list dense loading>
                <v-list-item v-for="(key, index) in filteredKeys" :key="index">
                  <v-list-item-content
                    class="font-weight-bold"
                    :class="{ 'accent--text': sortBy === key }"
                    >{{ key }}:</v-list-item-content
                  >
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-if="revenueFields.includes(key)"
                  >
                    {{ item[key.toLowerCase()] ? `$${formatCurrency(item[key.toLowerCase()])}` : 'No Data' }}
                  </v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-else-if="percentageFields.includes(key)"
                  >
                    {{ item[key.toLowerCase()] ? `${formatNumber(item[key.toLowerCase()])} %`: 'No Data' }}
                  </v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-else
                  >
                    {{ item[key.toLowerCase()] ? formatNumber(item[key.toLowerCase()]): 'No Data' }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="px-7 pt-2 pb-4" align="center" justify="center">
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark text color="primary" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text">Page {{ page }} of {{ numberOfPages }}</span>
          <v-btn small fab dark color="primary" class="mr-1" @click="formerPage">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn small fab dark color="primary" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'compkpi',
  props: [
    'organization',
    'group',
    'groupNum',
    'providers',
    'locations',
    'insurance',
    'startDate',
    'endDate',
    'data'
  ],
  data() {
    return {
      search: '',
      load: true,
      sortDesc: false,
      itemsPerPage: 4,
      itemsPerPageArray: [4, 8, 12],
      page: 1,
      pagination: '',
      sortBy: 'Membership',
      loading: false,
      keys: [
        'Membership',
        'MLR',
        'MRA',
        'Revenue',
        'Expenses',
        'ER Visits',
        'ER Visits Cost',
        'ER Visits Per 1000',
        'Admissions',
        'Admissions Cost',
        'Admits Per 1000',
        'Outpatient Costs',
        'Outpatient Visits',
        'Total Inpatient',
        'Average Stay',
        'Inpatient days per 1000',
        'Observations',
        'Observations Per 1000',
        'Brand Rx Count',
        'Brand Rx Cost',
        'All Rx Count',
        'Generic Rx Count',
        'GDR',
        'Readmissions',
        'Readmission Cost',
      ],
      revenueFields: [ 
        'Revenue',
        'Expenses',
        'ER Visits Cost',
        'Admissions Cost',
        'Outpatient Costs',
        'Brand Rx Cost',
        'Readmission Cost'
      ],
      percentageFields: [
        'MLR'
      ],
      membership: [],
      headers: [],
      patients: [],
      cancel: null,
      cancelSource: null,
    };
  },
  computed: {
    // Get pages and key, value pairs
    numberOfPages() {
      return Math.ceil(this.membership.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== 'Months');
    },
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    formatCurrency(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    },
    formatNumber(num) {
      if (num === undefined) {
        return 'No Data'
      } else {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }
    },
  },
  watch: {
    // Watch date inputs
    data() {
       this.data.forEach((info) => {
          info['er visits per 1000'] = !isNaN(((info['er visits'] / info.membership)* 1000).toFixed(2)) 
            ? ((info['er visits'] / info.membership) * 1000).toFixed(2) 
            : 'No Data';

          info['observations per 1000'] = !isNaN(((info.observations / info.membership)* 1000).toFixed(2)) 
            ? ((info.observations / info.membership)* 1000).toFixed(2) 
            : 'No Data';

          info['admits per 1000'] = !isNaN(((info.admissions / info.membership) * 1000).toFixed(2))
            ? ((info.admissions / info.membership) * 1000).toFixed(2) 
            : 'No Data';

          info['inpatient days per 1000'] = !isNaN(((info['total inpatient'] / info.membership) * 1000).toFixed(2))
            ? ((info['total inpatient'] / info.membership) * 1000).toFixed(2)
            : 'No Data';
            
          info.gdr = !isNaN(this.formatNumber((info['generic rx count'] / info['all rx count']).toFixed(2)))
           ? `${this.formatNumber((info['generic rx count'] / info['all rx count']).toFixed(2))}`
           : 'No Data';
        });
        this.membership = this.data;
    }
  }
};
</script>
